export default __webpack_public_path__ + "media/music/1ff7f2a0f0f216aadb8cec05c93f7b4c.mp3";